module.exports = __webpack_public_path__ + "img/edge_restauration_brasserie.ee1c5cbd.svg";